const services = [
  {
    icon: 'ri-layout-line',
    category: 'Website Design',
    title: 'Custom Website Development',
    description: 'Beautiful, responsive websites tailored to your brand. We create stunning designs that engage visitors and drive conversions across all devices.',
    gradient: 'from-[#1A1D29] to-[#14B8A6]'
  },
  {
    icon: 'ri-search-line',
    category: 'SEO Services',
    title: 'Search Engine Optimization',
    description: 'Boost your online visibility with proven SEO strategies. We optimize your website to rank higher in search results and attract quality traffic.',
    gradient: 'from-[#14B8A6] to-[#0D9488]'
  },
  {
    icon: 'ri-line-chart-line',
    category: 'Analytics',
    title: 'Performance Analytics',
    description: 'Track your success with comprehensive analytics. Monitor traffic, rankings, and conversions with our real-time SEO dashboard and reporting tools.',
    gradient: 'from-[#0D9488] to-[#1A1D29]'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-6">
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-3">Our Services</h2>
            <p className="text-3xl lg:text-4xl font-serif italic text-[#FF6B6B]">Tailored Solutions</p>
          </div>
          <p className="text-base text-gray-600 max-w-xl leading-relaxed">
            We provide comprehensive digital solutions designed to elevate your online presence. From stunning website design to powerful SEO strategies, we deliver results that matter.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 hover:transform hover:-translate-y-2 transition-all duration-300 shadow-sm hover:shadow-xl cursor-pointer"
            >
              <div className={`w-32 h-32 rounded-2xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-5xl text-white`}></i>
              </div>
              <div className="inline-block bg-[#84CC16] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
                {service.category}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
